var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagRuActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0759 24.1082C18.7033 24.1082 24.0759 18.7356 24.0759 12.1082C24.0759 5.48074 18.7033 0.108154 12.0759 0.108154C5.44851 0.108154 0.0759277 5.48074 0.0759277 12.1082C0.0759277 18.7356 5.44851 24.1082 12.0759 24.1082Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3295 16.282C23.8119 14.9821 24.0759 13.576 24.0759 12.1082C24.0759 10.6403 23.8119 9.23425 23.3295 7.93427H0.822318C0.339975 9.23425 0.0759277 10.6403 0.0759277 12.1082C0.0759277 13.576 0.339975 14.9821 0.822318 16.282L12.0759 17.3255L23.3295 16.282Z",
    fill: "#0052B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0759 24.1082C17.2355 24.1082 21.634 20.8517 23.3295 16.282H0.822266C2.51778 20.8517 6.9163 24.1082 12.0759 24.1082Z",
    fill: "#D80027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagRuActive);
export default __webpack_public_path__ + "static/media/flag-ru-active.c3b3d1251ae064cfe2a95ac055ddc99f.svg";
export { ForwardRef as ReactComponent };